module.exports = __webpack_public_path__ + "static/media/air-dark.0a6d53c6.svg";